export enum CableDirection {
  Both = 'Both',
  Left = 'Left',
  Right = 'Right'
}

// One cable, described by the unit (station/kabelskab) at each end and whether that end is earthed.
export interface CableUnit {
  leftEarth: boolean;
  leftUnit: string;
  direction: CableDirection;
  rightUnit: string;
  rightEarth: boolean;
}
